import { css } from 'styled-components'

export const not = <P>(...keys: (keyof P)[]) => (
  value: ((props: P) => string) | string,
) => (props: P) => {
  for (const key of keys) {
    if (props[key]) {
      return ''
    }
  }
  return typeof value === 'function' ? value(props) : value
}

export const check = <P>(...keys: (keyof P)[]) => (
  value: ((props: P) => string) | string,
) => (props: P) => {
  for (const key of keys) {
    if (props[key]) {
      return typeof value === 'function' ? value(props) : value
    }
  }
  return ''
}

export const checkBy = (property: string, mapping: {}) => (props: {}) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
  // @ts-ignore
  const value = mapping[props[property]]
  return typeof value === 'function' ? value(props) : value
}

export const fp = <O, K extends keyof O>(props: O, keys: K[]) => {
  const { ...newProps } = props

  for (const key of keys) {
    delete newProps[key]
  }

  return newProps as {
    [key in Exclude<keyof O, K>]: O[key]
  }
}

export const filterProps = fp

export const scrollbar = css`
  -webkit-overflow-scrolling: touch;

  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }

  ::-webkit-scrollbar-track {
    border-radius: 2px;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0);
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0);
  }

  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    transition: all 0.3s;
    background: rgba(0, 0, 0, 0.12);
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.12);
  }
`
